/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IComponentStyles } from '@fluentui/foundation-legacy';
import { IPivotStyleProps, IPivotStyles } from '@fluentui/react/lib/Pivot';
import { IStackProps, IStackSlots } from '@fluentui/react/lib/Stack';
import { IFontWeight } from '@fluentui/react/lib/Styling';
import { ITextProps, ITextSlots } from '@fluentui/react/lib/Text';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { ExpandableCardProps } from 'src/core/components/ExpandableCard';
import { getScopedTheme, getStylistV2 } from 'src/core/themes/luisStylist';

const { getClassName } = getStylistV2('DemoPage');

const stackStyler = classNamesFunction<IStackProps, IComponentStyles<IStackSlots>>();

export const demoTheme = getScopedTheme('DemoPage');
export const pageClass = getClassName('pageClass', { paddingTop: '0px !important' });
export const headerClassName = getClassName('headerClassName', { marginBottom: '0 !important' });
export const labelDescriptionIconClassName = getClassName('labelDescriptionIconClassName', { fontSize: '12px' });
export const resultPivotStyles = classNamesFunction<IPivotStyleProps, IPivotStyles>()({ text: { fontSize: '18px' } });
export const codeClassName = getClassName('codeClassName', { fontFamily: 'Consolas !important', whiteSpace: 'break-spaces' });
export const resultCardStyles = stackStyler({
    root: { padding: '12px 24px', boxShadow: demoTheme.boxShadow, maxWidth: '470px', minHeight: '120px' }
});
export const questionCardStyle = stackStyler({
    root: { padding: '12px 24px', boxShadow: demoTheme.boxShadow, maxWidth: '199px', minHeight: '166px' }
});
export const emptyResultWrapperStyles = stackStyler({
    root: { border: `1px solid ${demoTheme.resultWrapperBorderColor}`, minHeight: '400px' }
});
export const emptyResultStateTextStyles = classNamesFunction<ITextProps, IComponentStyles<ITextSlots>>()({
    root: { maxWidth: '287px', textAlign: 'center' }
});
export const resultWrapperStyles = stackStyler({
    root: {
        padding: '15px 20px 30px 20px',
        border: `1px solid ${demoTheme.resultWrapperBorderColor}`,
        minHeight: '500px',
        overflowY: 'auto'
    }
});
export const resultCardTitleStyles = (color: string, borderStyle: 'dashed' | 'solid' = 'solid') =>
    classNamesFunction<ITextProps, IComponentStyles<ITextSlots>>()({
        root: { borderBottom: `2px ${borderStyle} ${color}` }
    });
export const expandableCardStyles: (useHoverEffects: boolean, fontWeight?: IFontWeight) => ExpandableCardProps['styles'] = (
    useHoverEffects,
    fontWeight
) => ({
    contentContainer: { paddingBottom: '15px' },
    headerContainer: { padding: '10px 10px 10px 15px' },
    headerText: { fontSize: '14px !important', lineHeight: '14px', fontWeight: fontWeight ?? 'normal' },
    root: {
        boxShadow: 'none',
        transition: 'all 100ms ease-in',
        borderBottom: `1px solid ${demoTheme.sentenceCardBorderColor}`,
        ...(useHoverEffects ? { '&:hover': { zIndex: 1, boxShadow: demoTheme.boxShadow, backgroundColor: demoTheme.hoverColor } } : {})
    }
});
